import { IconProps } from '../../types/IconProps';

export const Phone = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    className={`${className || ''}`}>
    <g clipPath='url(#a)'>
      <path
        fill={variant === 'light' ? '#fff' : '#0B223E'}
        d='m20.414 15.109-4.386-1.966-.012-.005a1.49 1.49 0 0 0-1.482.182l-2.266 1.932c-1.436-.697-2.918-2.168-3.615-3.585l1.934-2.3a1.04 1.04 0 0 0 .053-.072 1.49 1.49 0 0 0 .123-1.402V7.88l-1.97-4.393a1.49 1.49 0 0 0-1.548-.886A5.238 5.238 0 0 0 2.69 7.804c0 7.392 6.015 13.407 13.407 13.407a5.238 5.238 0 0 0 5.202-4.555 1.49 1.49 0 0 0-.885-1.547Zm-4.317 4.612C9.518 19.714 4.187 14.383 4.18 7.804A3.743 3.743 0 0 1 7.426 4.08v.011l1.956 4.376-1.925 2.303a.577.577 0 0 0-.053.072 1.49 1.49 0 0 0-.093 1.462c.844 1.725 2.582 3.45 4.325 4.292a1.49 1.49 0 0 0 1.467-.106.793.793 0 0 0 .069-.052l2.263-1.93 4.376 1.96h.01a3.744 3.744 0 0 1-3.724 3.253Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M2 1.9h20v20H2z' />
      </clipPath>
    </defs>
  </svg>
);
